<template>
  <modal
    ref="downloadModal"
    @shown="onShown()"
    @hidden="onHidden()"
    id="download-modal"
    centered
    hide-footer
    hide-header
    content-class="downloadModal"
  >
    <template #default>
      <div class="title">Download starting...</div>
      <div class="description">
        <div>Did you know you don’t have to download to share?</div>
        <div>Copy and paste this link to share anywhere</div>
      </div>
      <div id="download-modal-share-url" class="share-url d-flex align-items-center justify-content-center">
        <copy-to-clipboard :label="item.links.share_url.replace(/(^\w+:|^)\/\//, '')" :value="item.links.share_url" container="download-modal-share-url" />
      </div>
      <video
        width="100%"
        height="auto"
        autoplay=""
        loop=""
        playsinline=""
        muted=""
        preload="auto"
        poster="https://assets-global.website-files.com/58e32bace1998d6e3fee8d71/5fc860e4773d303f11605d9e_ca_feature_animation_poster.png"
      >
        <source
          src="https://p-ynfww3.b2.n0.cdn.getcloudapp.com/items/Jruq72D1/ca_feature-animation-01--prod.mp4"
          type="video/mp4"
        />
        <source
          src="https://p-ynfww3.b2.n0.cdn.getcloudapp.com/items/d5uPeo1d/ca_feature-animation-01--prod.webm"
          type="video/webm"
        />
        Your browser doesn't support HTML5 video. Download it
        <a
          href="https://p-ynfww3.b2.n0.cdn.getcloudapp.com/items/Jruq72D1/ca_feature-animation-01--prod.mp4"
          download=""
        >
          here
        </a>
      </video>

      <div>
        <a
          id="viewer-download-link"
          data-testid="viewer-download-link"
          title="Download Drop"
          :href="
            $root.routes.viewer_download_item_url({
              slug: item.id,
              filename: item.attributes.name,
              utm_source: 'viewer',
            })
          "
        ></a>
      </div>
    </template>
  </modal>
</template>

<script>
import { mapState } from "vuex";
import track from "@/src/tracking";
import Modal from "@cmp/modal";
import CopyToClipboard from "@cmp/copy_to_clipboard.vue";

export default {
  data: function () {
    return {
      timer: null,
    };
  },
  components: { Modal, CopyToClipboard },
  computed: {
    ...mapState({
      currentUser: (state) => state.user,
      item: (state) => state.item,
    }),
  },
  methods: {
    onShown: function () {
      this.timer = setTimeout(() => {
        document.getElementById("viewer-download-link").click();
      }, 5000);
    },
    onHidden: function () {
      if (this.timer) {
        clearTimeout(this.timer);
      }
    },
  },
};
</script>

<style lang="scss">
@import "@/packs/application.scss";

.modal-content.downloadModal {
  padding: 1.75rem 2rem;
  border-radius: 16px;
  box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.08);
  border: solid 0.5px #b5b5b5;
  background-color: $white;
  font-family: SFPro;
  text-align: center;

  .copy-link {
    padding-left: 0.5rem !important;
  }
}
</style>

<style lang="scss" scoped>
@import "@/packs/application.scss";

.title {
  color: #000;
  font-size: 2rem;
  font-weight: 600;
}

.description {
  padding: 2rem 0;
  font-size: 1rem;
  line-height: 1.5;
  color: #333;
}
</style>
